// src/landing/components/MainSection.js
import React, { useContext } from 'react';
import '../styles/MainSection.css';          // 전용 스타일
import { LanguageContext } from '../../common/contexts/LanguageContext';

// public/assets 폴더의 이미지 경로
const googleBadge   = '/assets/google_play_badge.png';
const appstoreBadge = '/assets/app_store_badge.png';
const phonesImg     = '/assets/phones.png';

export default function MainSection() {
  const { t } = useContext(LanguageContext);

  return (
    <section id="main" className="main-section">
      {/* 가운데 정렬·최대 폭을 위한 래퍼 */}
      <div className="main-inner">
        {/* ── 왼쪽 텍스트 영역 ── */}
        <div className="main-left">
          <h1>
            {t('mainSection.headingLine1')}
            <br />
            {t('mainSection.headingLine2')}
          </h1>
          <p className="sub">
            {t('mainSection.sub')}
          </p>

          {/* 스토어 배지 */}
          <div className="store-badges">
            <a href={t('mainSection.downloadLink.play')}>
              <img src={googleBadge} alt={t('mainSection.alt.googlePlay')} />
            </a>
            <a href={t('mainSection.downloadLink.appstore')}>
              <img src={appstoreBadge} alt={t('mainSection.alt.appStore')} />
            </a>
          </div>
        </div>

        {/* ── 오른쪽 휴대폰 이미지 ── */}
        <div className="main-right">
          <img src={phonesImg} alt={t('mainSection.alt.phonesImg')} />
        </div>
      </div>
    </section>
  );
}
